import { OnInit, ElementRef, EventEmitter, OnDestroy } from '@angular/core';
import { DetailProperty } from '../objects/DetailObject';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfirmationService } from '../services/confirmation.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { SessionTimerService } from '../services/session-timer.service';
import { AttachmentService } from '../services/attachment.service';
import { DetailService } from '../services/detail.service';
import { ScrollService } from '../services/scroll.service';
var AttachmentComponent = /** @class */ (function () {
    function AttachmentComponent(eRef, sanitizer, confirmationService, themeSettingService, sessionTimerService, attachmentService, detailService, scrollService) {
        var _this = this;
        this.eRef = eRef;
        this.sanitizer = sanitizer;
        this.confirmationService = confirmationService;
        this.themeSettingService = themeSettingService;
        this.sessionTimerService = sessionTimerService;
        this.attachmentService = attachmentService;
        this.detailService = detailService;
        this.scrollService = scrollService;
        this.allowedFormats = ["pdf", "png", "jpg", "docx", "doc", "xlsx", "xls", "ppt", "pptx", "pdf", "jpg", "jpeg", "gif", "png", "bmp",
            "dtsconfig", "xml", "dtsx", "mdd", "mcf", "txt", "csv", "zip", "rar", "eml"];
        this.attachmentIsMultiple = false;
        this.attachments = new EventEmitter();
        this.optionalChanged = new EventEmitter();
        this.fileList = [];
        this.maxFileSizeKb = 10000;
        this.isEditable = false;
        this.isOptional = false;
        this.isNotApplicable = false;
        this.isDeleteAll = false;
        this.isUploading = false;
        this.onBlur = false;
        this.isBusy = false;
        this.isInvalid = false;
        this.isDisabled = false;
        this.defaultGuid = "00000000-0000-0000-0000-000000000000";
        this.files = [];
        this.onBlur = false;
        this.sub1 = this.detailService.currentPropertyFocusChanged$.subscribe(function (result) {
            if (_this.propertyId == result) {
                _this.scrollService.triggerScrollTo(_this.fileContainer);
            }
        });
    }
    Object.defineProperty(AttachmentComponent.prototype, "setComponentId", {
        set: function (id) {
            this.componentId = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AttachmentComponent.prototype, "setProperty", {
        set: function (property) {
            this.propertyId = property.PropertyId;
            this.propertyName = property.PropertyName;
            this.propertyDisplay = property.PropertyDisplay;
            this.isEditable = property.PropertyIsEditable;
            this.isOptional = property.PropertyFormControlType.toUpperCase().indexOf("OPTIONAL") > -1;
            if (this.isOptional) {
                if (property.PropertyValue == this.defaultGuid) {
                    this.isNotApplicable = true;
                    this.optionalFileToggle({ checked: true }, false);
                }
            }
            this.getFileList();
            this.getFilesSettings();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AttachmentComponent.prototype, "setInvalid", {
        set: function (invalid) {
            this.isInvalid = invalid;
        },
        enumerable: true,
        configurable: true
    });
    AttachmentComponent.prototype.clickout = function (event) {
        if (this.eRef.nativeElement.contains(event.target)) {
            this.onBlur = false;
        }
        else {
            this.onBlur = true;
            this.currentFileId = null;
            this.isDeleteAll = false;
        }
    };
    AttachmentComponent.prototype.onFileChange = function (event) {
        this.errorMessage = null;
        var fileList = event.target.files;
        if (this.isDisabled)
            return false;
        if (fileList.length > 0) {
            this.uploadAttachment(fileList, 0);
        }
    };
    AttachmentComponent.prototype.uploadAttachment = function (files, index, uploadSuccess) {
        var _this = this;
        if (uploadSuccess === void 0) { uploadSuccess = false; }
        if (this.allowedFormats.indexOf(files[index].name.split('.').pop().toLowerCase()) > -1 && files[index].name.indexOf(".") > -1) {
            if (files[index].size / 1000 < this.maxFileSizeKb) {
                this.isUploading = true;
                this.sessionTimerService.resetSessionTimer();
                this.attachmentService.uploadAttachment(this.componentId, this.propertyId, encodeURIComponent(files[index].name), files[index]).subscribe(function (result) {
                    if (result == "1") {
                        index++;
                        if (files.length > index) {
                            _this.uploadAttachment(files, index, true);
                        }
                        else {
                            _this.getFileList();
                            _this.isUploading = false;
                        }
                    }
                    else {
                        _this.getFileList();
                        _this.isUploading = false;
                    }
                }, function (error) {
                    _this.isUploading = false;
                    _this.fileControl.nativeElement.value = "";
                });
            }
            else {
                if (uploadSuccess)
                    this.getFileList();
                this.isUploading = false;
                this.handleFileErrorMessage(FileErrorType.INVALID_SIZE);
            }
        }
        else {
            if (uploadSuccess)
                this.getFileList();
            this.isUploading = false;
            this.handleFileErrorMessage(FileErrorType.INVALID_FORMAT);
        }
    };
    AttachmentComponent.prototype.getFileList = function (emit) {
        var _this = this;
        if (emit === void 0) { emit = true; }
        if (this.componentId && this.propertyId) {
            this.attachmentService.getAttachmentList(this.componentId, this.propertyId).subscribe(function (result) {
                if (result) {
                    _this.fileList = JSON.parse(result);
                    if (emit)
                        _this.attachments.emit(_this.fileList.map(function (x) { return x.AttachmentId; }).join(","));
                    _this.sortFileList();
                    _this.fileList.forEach(function (file) {
                        //this.requestDownloadFile(file);
                    });
                }
                else {
                    _this.fileList = [];
                    if (emit)
                        _this.attachments.emit(null);
                }
                _this.isFileChange = null;
                _this.isUploading = false;
                _this.isBusy = false;
            }, function (error) {
                _this.isBusy = false;
            });
        }
    };
    AttachmentComponent.prototype.sortFileList = function () {
        this.fileList = this.fileList.sort(function (a, b) {
            if (a.AttachmentName.toLowerCase() > b.AttachmentName.toLowerCase()) {
                return 1;
            }
            else if (a.AttachmentName.toLowerCase() < b.AttachmentName.toLowerCase()) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    AttachmentComponent.prototype.getFilesSettings = function () {
        var _this = this;
        this.attachmentService.getMaximumFileUploadSize().subscribe(function (result) {
            if (result) {
                _this.maxFileSizeKb = Number(result);
            }
        });
        this.attachmentService.getAllowedFileTypes().subscribe(function (result) {
            if (result) {
                _this.allowedFormats = result.split(',');
                _this.allowedFormatsString = _this.allowedFormats.join(' ');
                var array = [];
                _this.allowedFormats.forEach(function (element) {
                    var newEl = "." + element;
                    array.push(newEl);
                });
                _this.acceptFormatString = array.toString();
            }
        });
    };
    AttachmentComponent.prototype.requestDownloadFile = function (file) {
        var _this = this;
        this.isBusy = true;
        this.attachmentService.downloadFile(file.AttachmentId).subscribe(function (data) {
            _this.downloadFile(file, data);
        });
        return false;
    };
    AttachmentComponent.prototype.downloadFile = function (file, data) {
        var a = document.createElement('a');
        a.href = window.URL.createObjectURL(data);
        a.download = file.AttachmentName;
        a.dispatchEvent(new MouseEvent('click'));
        this.isBusy = false;
        //file.AttachmentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(data));
    };
    AttachmentComponent.prototype.deleteAll = function () {
        var _this = this;
        this.confirmationService.confirm("Delete all files ?", "<p class='normal-message'>All files in " + this.propertyDisplay + " will be permanently deleted</p>", ["CANCEL, CANCEL", "OK"], false, "", false, "", false, "delete")
            .subscribe(function (respond) {
            if (respond.answer == "OK") {
                _this.deleteAllConfirmed();
            }
        });
    };
    AttachmentComponent.prototype.deleteAllConfirmed = function (emit) {
        var _this = this;
        if (emit === void 0) { emit = false; }
        this.isBusy = true;
        var attachmentIds = this.fileList.map(function (a) { return a.AttachmentId; });
        var param;
        param = { name: "attachmentIdList", value: JSON.stringify(attachmentIds) };
        this.attachmentService.deleteAllFile(param, this.componentId, this.propertyId).subscribe(function (result) {
            _this.fileControl.nativeElement.value = "";
            _this.getFileList(emit);
        }, function (error) {
            _this.isBusy = false;
        });
    };
    AttachmentComponent.prototype.deleteFile = function (id) {
        this.currentFileId = id;
        this.onBlur = false;
    };
    AttachmentComponent.prototype.deleteConfirmed = function (id) {
        var _this = this;
        this.currentFileId = null;
        this.isFileChange = id;
        this.errorMessage = null;
        this.attachmentService.deleteFile(id, this.componentId, this.propertyId).subscribe(function (data) {
            _this.fileControl.nativeElement.value = "";
            _this.onBlur = true;
            _this.getFileList();
        });
    };
    AttachmentComponent.prototype.ngOnInit = function () {
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
        this.allowedFormatsString = this.allowedFormats.join(' ');
        var array = [];
        this.allowedFormats.forEach(function (element) {
            var newEl = "." + element;
            array.push(newEl);
        });
        this.acceptFormatString = array.toString();
    };
    AttachmentComponent.prototype.ngOnDestroy = function () {
        if (this.sub1)
            this.sub1.unsubscribe();
    };
    AttachmentComponent.prototype.dropped = function (event) {
        this.files = event.files;
        if (this.isDisabled)
            return false;
        if (this.files.length > 1 && !this.attachmentIsMultiple) {
            this.errorMessage = "Only one file is allowed for " + this.propertyDisplay.toLowerCase() + " field";
        }
        else {
            this.errorMessage = null;
            this.droppedAttachments(this.files, 0);
        }
    };
    AttachmentComponent.prototype.droppedAttachments = function (fileList, index, uploadSuccess) {
        var _this = this;
        if (uploadSuccess === void 0) { uploadSuccess = false; }
        var droppedFile = fileList[index];
        var fileName = droppedFile.fileEntry.name;
        // Is it a file?
        if (droppedFile.fileEntry.isFile) {
            if (this.allowedFormats.indexOf(fileName.split('.').pop().toLowerCase()) > -1 && fileName.indexOf(".") > -1) {
                var fileEntry = droppedFile.fileEntry;
                fileEntry.file(function (file) {
                    if (file.size / 1000 < _this.maxFileSizeKb) {
                        _this.isUploading = true;
                        _this.sessionTimerService.resetSessionTimer();
                        _this.attachmentService.uploadAttachment(_this.componentId, _this.propertyId, encodeURIComponent(file.name), file).subscribe(function (result) {
                            if (result == "1") {
                                index++;
                                if (fileList.length > index && _this.attachmentIsMultiple) {
                                    _this.droppedAttachments(fileList, index, true);
                                }
                                else {
                                    _this.getFileList();
                                    _this.isUploading = false;
                                }
                            }
                            else {
                                _this.getFileList();
                                _this.isUploading = false;
                            }
                        }, function (error) {
                            _this.isUploading = false;
                            _this.fileControl.nativeElement.value = "";
                        });
                    }
                    else {
                        if (uploadSuccess)
                            _this.getFileList();
                        _this.isUploading = false;
                        _this.handleFileErrorMessage(FileErrorType.INVALID_SIZE);
                    }
                });
            }
            else {
                if (uploadSuccess)
                    this.getFileList();
                this.handleFileErrorMessage(FileErrorType.INVALID_FORMAT);
            }
        }
        else {
            // It was a directory (empty directories are added, otherwise only files)
            var fileEntry = droppedFile.fileEntry;
            console.log(droppedFile.relativePath, fileEntry);
        }
    };
    AttachmentComponent.prototype.handleFileErrorMessage = function (fileErrorType) {
        switch (fileErrorType) {
            case FileErrorType.INVALID_FORMAT:
                this.errorMessage = "File format is not valid";
                break;
            case FileErrorType.INVALID_SIZE:
                if (this.attachmentIsMultiple) {
                    this.errorMessage = "Please make sure each file size does not exceed the maximum file upload size";
                }
                else {
                    this.errorMessage = "Please make sure the file size does not exceed the maximum file upload size";
                }
                break;
        }
    };
    AttachmentComponent.prototype.optionalFileToggle = function (event, userInteract) {
        if (userInteract === void 0) { userInteract = true; }
        this.isDisabled = event.checked;
        if (this.isDisabled && userInteract) {
            this.deleteAllConfirmed(false);
            this.attachments.emit(this.defaultGuid);
        }
        this.optionalChanged.emit(event.checked);
    };
    AttachmentComponent.prototype.fileOver = function (event) {
        //console.log(event);
    };
    AttachmentComponent.prototype.fileLeave = function (event) {
        //console.log(event);
    };
    return AttachmentComponent;
}());
export { AttachmentComponent };
export var FileErrorType;
(function (FileErrorType) {
    FileErrorType[FileErrorType["INVALID_FORMAT"] = 0] = "INVALID_FORMAT";
    FileErrorType[FileErrorType["INVALID_SIZE"] = 1] = "INVALID_SIZE";
})(FileErrorType || (FileErrorType = {}));
